const trackingDetails = {
  wiseOwlButtonActionClicked: (buttonText: string) =>
    `Help Center Assistant ${buttonText} Button Action Clicked`,
  wiseOwlPromptSuggestionClicked:
    "Help Center Assistant Prompt Suggestion Clicked",
  wiseOwlLinkClicked: "Help Center Assistant Link Clicked",
  wiseOwlChatCreated: "Help Center Assistant Message Created",
  wiseOwlMessageSent: "Help Center Assistant Message Sent",
  wiseOwlFeedbackSent: "Help Center Assistant Feedback Sent",
  wiseOwlFeedbackLogin: "Help Center Assistant Feedback Login",
};

export { trackingDetails };
